import axios from 'axios';
// import qs from 'qs';
// require('pace-js/themes/orange/pace-theme-minimal.css');

/**
 * axios 配置
 */
axios.defaults.timeout = 120000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.baseURL = 'http://222.181.10.230:8030/';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.post['allSource'] = 'PC';
// axios.defaults.headers.post['timestamp'] = new Date().getTime();
// Axios实现请求重试
axios.defaults.retry = 1; // 重试次数
axios.defaults.retryDelay = 1000; // 重试延时
axios.defaults.shouldRetry = () => true; // 重试条件，默认只要是错误都需要重试

axios.defaults.requestCount = 0;
// 请求拦截器
axios.interceptors.request.use(config => {
	return config;
}, err => {
	return Promise.resolve(err);
})

// 响应拦截器
axios.interceptors.response.use(response => {
	return response;
}, err => {
	return Promise.resolve(err);
})


/* 封装post方法 */
export function POST(url, data = {}) {
	return new Promise((resolve, reject) => {
		// const params = qs.stringify(data);
		let params = data;
		let headers = {
			"Content-Type": "application/json;charset=utf-8;",
			"callSource": "PC",
			"timestamp": new Date().getTime()
		}
		axios.post('/webapi' + url, params, {
			headers
		}).then(response => {
			resolve(response);
		}).catch(err => {
			reject(err);
		})
	})
}

export function GET(url) {
	let headers = {
		'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
	}
	return new Promise((resolve, reject) => {
		axios.get('/webapi' + url, {
			headers
		}).then(response => {
			if (response) {
				resolve(response.data);
			}
		}).catch(err => {
			reject(err);
		})
	})
}
